"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInternalLoan = exports.mapStatusChoices = exports.isObjectEmpty = exports.formatDuration = exports.isWorkingHour = exports.registerServiceWorker = exports.validatePhoneNumber = exports.validateIsAlpha = exports.isEmptyOrUndefined = exports.isScoreParametersValid = exports.validateIsDigit = exports.encodeUrlParams = exports.getStatusTextStyle = exports.getStatusBackgroundStyle = exports.isColor = exports.formatKey = exports.formatTitle = exports.getCallStatusByOption = exports.getCallTypeByOption = exports.voipCallInProgress = exports.getTimeUsed = exports.formatDateString = exports.convertObjToPlainString = exports.formatDateISOString = exports.formatNumber = exports.ServerError = exports.getError = void 0;
const dayjs_1 = __importDefault(require("dayjs"));
const duration_1 = __importDefault(require("dayjs/plugin/duration"));
const communicationBoxConstants_1 = require("../components/communicationBox/communicationBoxConstants");
const constants_1 = require("../constants/constants");
const colors_1 = __importDefault(require("../styles/colors"));
const styles_1 = __importDefault(require("../styles/styles"));
const callFeedBackConstants_1 = require("../components/communicationBox/callFeedback/callFeedBackConstants");
const getError = (field, object) => {
    // maybe we'll need to improve this, now just getting the first error in the list
    if (object && object[field])
        return object[field][0];
    return null;
};
exports.getError = getError;
class ServerError extends Error {
    code;
    message;
    errorObject;
    constructor({ code, message, errorObject }) {
        super(message);
        this.code = code;
        this.message = message;
        this.errorObject = errorObject;
    }
}
exports.ServerError = ServerError;
const formatNumber = (amount) => {
    return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
exports.formatNumber = formatNumber;
const formatDateISOString = (date) => {
    return date.toISOString().split('T')[0];
};
exports.formatDateISOString = formatDateISOString;
/**
 * Converts an error object in the format {"id":["Enter a valid UUID."]}
 * to "id: Enter a valid UUID., name: ...".
 * @param {Object} errorObj - The error object to convert.
 * @returns {string} - The converted error string.
 */
const convertObjToPlainString = (errorObj) => Object.entries(errorObj)
    .map(([key, [value]]) => `${key}: ${value}`)
    .join(', ');
exports.convertObjToPlainString = convertObjToPlainString;
/**
 * Format a datetime/date string into humanized format.
 * Converts datetime into 'DD MMM YYYY HH:mm' format.
 * Converts date into 'DD MMM YYYY' format.
 */
const formatDateString = (date, hasHours = true) => {
    const formatString = hasHours ? 'DD MMM YYYY HH:mm' : 'DD MMM YYYY';
    return dayjs_1.default(date).format(formatString);
};
exports.formatDateString = formatDateString;
const getTimeUsed = (startDatetime, endDatetime) => {
    dayjs_1.default.extend(duration_1.default);
    const dateStartedObj = dayjs_1.default(startDatetime);
    const dateEndedObj = dayjs_1.default(endDatetime);
    if (dateEndedObj.isBefore(dateStartedObj)) {
        // Handle the case where the endDatetime is before the startDatetime
        return callFeedBackConstants_1.TIMER_START_VALUE;
    }
    return dayjs_1.default.duration(dateEndedObj.diff(dateStartedObj)).format('HH:mm:ss');
};
exports.getTimeUsed = getTimeUsed;
const voipCallInProgress = (callStatus) => {
    return [communicationBoxConstants_1.CONFIRMED, communicationBoxConstants_1.CONNECTING].includes(callStatus);
};
exports.voipCallInProgress = voipCallInProgress;
const getCallTypeByOption = (option) => {
    let result;
    /* eslint indent: [2, 4, {"SwitchCase": 1}] */
    switch (option) {
        case '0':
            result = 'Voip Call';
            break;
        case '1':
            result = 'Regular Call';
            break;
        default:
            result = 'NA';
            break;
    }
    return result;
};
exports.getCallTypeByOption = getCallTypeByOption;
const getCallStatusByOption = (option) => {
    let result;
    /* eslint indent: [2, 4, {"SwitchCase": 1}] */
    switch (option) {
        case '0':
            result = 'Answered';
            break;
        case '1':
            result = 'Not Answered';
            break;
        case '2':
            result = 'Promised';
            break;
        case '4':
            result = 'Call Dropped';
            break;
        case '5':
            result = "Customer couldn't hear me";
            break;
        case '6':
            result = "I couldn't hear customer";
            break;
        case '7':
            result = "Call didn't connect";
            break;
        case '8':
            result = 'Other';
            break;
        default:
            result = 'NA';
            break;
    }
    return result;
};
exports.getCallStatusByOption = getCallStatusByOption;
const formatTitle = (key) => key
    .split('_') // creates list of all words in key
    .map((word) => word[0].toUpperCase() + word.substring(1)) // goes through all words and capitalizes first letter
    .join(' '); // joins all updated words in a single string
exports.formatTitle = formatTitle;
/**
 * Format a string into a key.
 * E.g converts `This Key` to `this_key`
 *
 */
const formatKey = (key) => key.toLowerCase().replace(' ', '_');
exports.formatKey = formatKey;
const isColor = (strColor) => {
    const s = new Option().style;
    s.color = strColor;
    // Options only accept valid color.
    return s.color.length > 0;
};
exports.isColor = isColor;
const getStatusBackgroundStyle = (color) => {
    return {
        backgroundColor: color && exports.isColor(color) ? color : colors_1.default.BLUE,
        opacity: 0.7,
    };
};
exports.getStatusBackgroundStyle = getStatusBackgroundStyle;
const getStatusTextStyle = (color) => color !== 'yellow' ? styles_1.default.textColorWhite : styles_1.default.textColorBlack;
exports.getStatusTextStyle = getStatusTextStyle;
/**
 * Converts an object of URL parameters into an encoded URL query string.
 * Handles both single values and arrays of values for each parameter.
 *
 * @param urlParameters - Object containing parameter keys and their values
 * @returns Encoded URL query string
 *
 * @example
 * encodeUrlParameters({ name: "John", colors: ["red", "blue"] })
 * // Returns: "name=John&colors=red&colors=blue"
 */
const encodeUrlParams = (params) => {
    const searchParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (Array.isArray(value)) {
            // Append multiple values for the same key
            value.forEach((item) => searchParams.append(key, item));
        }
        else {
            // Append a single value
            searchParams.append(key, value);
        }
    });
    return searchParams.toString();
};
exports.encodeUrlParams = encodeUrlParams;
const validateIsDigit = (stringDigit) => {
    return !constants_1.ONLY_DIGIT_REGEX.test(stringDigit) ? constants_1.NUMBER_INVALID_ERROR : '';
};
exports.validateIsDigit = validateIsDigit;
const isScoreParametersValid = (score) => {
    return score !== undefined && score !== '';
};
exports.isScoreParametersValid = isScoreParametersValid;
const isEmptyOrUndefined = (value) => ['', undefined, null].includes(value);
exports.isEmptyOrUndefined = isEmptyOrUndefined;
const validateIsAlpha = (str) => {
    return !constants_1.ONLY_ALPHA_REGEX.test(str) ? constants_1.ALPHA_INVALID_ERROR : '';
};
exports.validateIsAlpha = validateIsAlpha;
const validatePhoneNumber = (phoneNumber) => {
    let error = '';
    // Confirm phone number only contains digits
    const digitError = exports.validateIsDigit(phoneNumber);
    if (digitError) {
        error = digitError;
    }
    // Validate length.
    else if (phoneNumber.length < 8) {
        error = constants_1.NUMBER_TOO_SHORT_ERROR;
    }
    else if (phoneNumber.length > 13) {
        error = constants_1.NUMBER_TOO_LONG_ERROR;
    }
    return error;
};
exports.validatePhoneNumber = validatePhoneNumber;
const registerServiceWorker = () => {
    if ('serviceWorker' in navigator) {
        window.addEventListener('load', async () => {
            await navigator.serviceWorker.register('/service-worker.js', {
                scope: '/',
            });
        });
    }
};
exports.registerServiceWorker = registerServiceWorker;
/**
 * Check if current time is within work hours.
 *
 */
const isWorkingHour = () => {
    const currentTime = new Date();
    const hours = currentTime.getHours() + currentTime.getMinutes() / 60;
    // Using 7:30 instead of 8 to enable officers unpause before support calls start coming in.
    if (hours >= 7.5 && hours <= 20) {
        return true;
    }
    return false;
};
exports.isWorkingHour = isWorkingHour;
// Format time
const padTo2Digits = (num) => {
    return num.toString().padStart(2, '0');
};
/**
 * Format time in seconds to `HH:MM:SS` format.
 *
 */
const formatDuration = (durationInSeconds, isSimple = false) => {
    const seconds = Math.floor(durationInSeconds) % 60;
    const minutes = Math.floor(durationInSeconds / 60) % 60;
    const hours = Math.floor(durationInSeconds / 3600);
    if (isSimple && hours === 0)
        return `${padTo2Digits(minutes)}:${padTo2Digits(seconds)}`;
    return `${padTo2Digits(hours)}:${padTo2Digits(minutes)}:${padTo2Digits(seconds)}`;
};
exports.formatDuration = formatDuration;
/**
 * Checks if the given object is empty.
 *
 */
const isObjectEmpty = (obj) => {
    // Check if obj is neither null nor undefined and is an object
    if (typeof obj !== 'object' || obj === null) {
        return true;
    }
    // Now we know obj is an object, so it's safe to call Object.keys()
    return Object.keys(obj).length === 0;
};
exports.isObjectEmpty = isObjectEmpty;
/**
 * Converts an array of `Choice` objects into a Map where `value` becomes the key
 * and `label` becomes the value. Excludes entries with empty or undefined values.
 *
 * @param {Choice[]} choices - Array of `Choice` objects with 'value' and 'label' properties.
 * @returns {Map<string | number, string>} A Map with 'value' as key and 'label' as value, excluding empty or undefined values.
 */
const mapStatusChoices = (choices) => {
    return choices.reduce((acc, { value, label }) => {
        if (value !== undefined && value !== '') {
            // Check to exclude empty or undefined values
            acc.set(value.toString(), label);
        }
        return acc;
    }, new Map()); // Initialize with a new Map
};
exports.mapStatusChoices = mapStatusChoices;
// Distinguishes InternalLoan from external Loan by the presence of loan_id on loan_data
const isInternalLoan = (loan) => {
    return loan !== null && 'loan_id' in loan.loan_data;
};
exports.isInternalLoan = isInternalLoan;
